/* Quick add (§6.4). Cards for products with options link to the product page; with JS that link
   opens a side drawer with the product's variant picker (sections/quick-add.liquid). Adding hands
   over to the cart drawer. Loaded only when Theme settings → Product cards → Quick add is on. */
(() => {
  if (window.Theme.quickAddReady) return;
  window.Theme.quickAddReady = true;

  const { config } = window.Theme;
  let drawer;
  let body;
  let productFormLoading;

  function ensureDrawer() {
    if (drawer) return;
    drawer = document.createElement('theme-dialog');
    drawer.id = 'QuickAdd';
    drawer.innerHTML = `
      <dialog class="dialog dialog--right" aria-labelledby="QuickAddTitle">
        <div class="dialog__panel qa-panel surface-cloud">
          <div class="qa-panel__head">
            <button type="button" class="icon-btn" data-dialog-close data-dialog-focus></button>
          </div>
          <div class="qa-panel__body" data-quick-add-body></div>
        </div>
      </dialog>`;
    const close = drawer.querySelector('[data-dialog-close]');
    close.setAttribute('aria-label', config.strings.close);
    close.innerHTML = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    document.body.append(drawer);
    body = drawer.querySelector('[data-quick-add-body]');
  }

  // Scripts inserted with innerHTML don't run, so product-form.js is loaded here once.
  function loadProductForm() {
    if (customElements.get('product-info')) return Promise.resolve();
    if (!productFormLoading) {
      productFormLoading = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = config.assets.productForm;
        script.onload = resolve;
        script.onerror = reject;
        document.head.append(script);
      });
    }
    return productFormLoading;
  }

  // Wait for the section's stylesheets so the drawer never shows unstyled content.
  function loadStyles(doc) {
    const links = [...doc.querySelectorAll('link[rel="stylesheet"]')].filter(
      (link) => !document.querySelector(`link[href="${link.getAttribute('href')}"]`)
    );
    return Promise.all(
      links.map(
        (link) =>
          new Promise((resolve) => {
            const el = document.createElement('link');
            el.rel = 'stylesheet';
            el.href = link.getAttribute('href');
            el.onload = el.onerror = resolve;
            document.head.append(el);
          })
      )
    );
  }

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest && event.target.closest('[data-quick-add]');
    if (!trigger) return;
    event.preventDefault();
    ensureDrawer();
    window.Theme.quickAddOpener = trigger;
    body.setAttribute('aria-busy', 'true');
    body.textContent = config.strings.loading;
    drawer.open(trigger);

    try {
      const url = new URL(trigger.dataset.quickAdd, window.location.origin);
      url.searchParams.set('section_id', 'quick-add');
      const [html] = await Promise.all([fetch(url).then((r) => (r.ok ? r.text() : Promise.reject(r.status))), loadProductForm()]);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      await loadStyles(doc);
      const root = doc.querySelector('[data-quick-add-root]');
      if (!root) throw new Error('Quick add section missing');
      body.replaceChildren(root);
      body.removeAttribute('aria-busy');
      (root.querySelector('[data-variant-picker] input:checked') || root.querySelector('button, a'))?.focus();
    } catch (error) {
      window.location.href = trigger.href;
    }
  });

  // Hand over to the cart drawer without bouncing focus back to the card.
  document.addEventListener('cart:added', (event) => {
    if (drawer && drawer.isOpen && drawer.contains(event.detail.form)) drawer.close({ restoreFocus: false });
  });
})();
